window.prettyNumber = function (number, del = ' ') {
    var res = new Intl.NumberFormat().format(number);
    return res.replace(/,/g, del)
}